import {
  OFFLINE_QUEUE_STORAGE_KEY,
  UPLOAD_STORAGE_KEY,
  dispatchScopedStorageUpdate,
  hasCaseScope,
  hasUserScope,
  itemUserId,
  normalizeCaseCode,
  normalizeUserId,
  readActiveCaseSession,
  readJson,
  writeActiveCaseSession,
  writeJson,
} from "./case-scoped-storage";

const pruneTransientState = (session, previous) => {
  const userChanged = previous?.userId !== session.userId;
  const activeUserId = normalizeUserId(session.userId);
  const activeCaseCode = normalizeCaseCode(session.caseCode);

  const keepItem = (item) => {
    if (!hasCaseScope(item) || !hasUserScope(item)) return false;
    if (!userChanged) return true;
    if (!activeUserId) return false;
    return itemUserId(item) === activeUserId;
  };

  const queue = readJson(OFFLINE_QUEUE_STORAGE_KEY, []);
  const scopedQueue = queue.filter(keepItem);
  if (scopedQueue.length !== queue.length) {
    writeJson(OFFLINE_QUEUE_STORAGE_KEY, scopedQueue);
  }

  const uploads = readJson(UPLOAD_STORAGE_KEY, []);
  const scopedUploads = uploads.filter(keepItem);
  if (scopedUploads.length !== uploads.length) {
    writeJson(UPLOAD_STORAGE_KEY, scopedUploads);
  }

  dispatchScopedStorageUpdate(
    "offline-queue:updated",
    OFFLINE_QUEUE_STORAGE_KEY,
    activeCaseCode,
    activeUserId
  );
  dispatchScopedStorageUpdate("uploads:updated", UPLOAD_STORAGE_KEY, activeCaseCode, activeUserId);
  window.dispatchEvent(new CustomEvent("lead-draft:updated", { detail: null }));
};

const CaseSessionHook = {
  mounted() {
    this.sync();
  },
  updated() {
    this.sync();
  },
  sync() {
    const session = {
      userId: normalizeUserId(this.el.dataset.userId) || null,
      caseCode: normalizeCaseCode(this.el.dataset.caseCode) || null,
    };

    const previous = readActiveCaseSession();
    const changed =
      previous &&
      (previous.userId !== session.userId || previous.caseCode !== session.caseCode);

    if (changed) {
      pruneTransientState(session, previous);
    }

    writeActiveCaseSession(session);
  },
};

export default CaseSessionHook;
